import { Clear, Search } from '@mui/icons-material'
import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
  useTheme,
} from '@mui/material'

import rem from '~/utils/ui'

type TProps = {
  searchValue: string
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleClearSearch: () => void
  style?: React.CSSProperties
  placeholder?: string
} & TextFieldProps

function SearchInput({
  searchValue,
  handleClearSearch,
  handleSearch,
  style = undefined,
  placeholder = 'Search',
  ...props
}: TProps) {
  const theme = useTheme()

  return (
    <TextField
      variant="standard"
      placeholder={placeholder}
      value={searchValue}
      onChange={handleSearch}
      sx={{
        '& .MuiInputBase-root': {
          padding: rem(5),
        },
        '& svg': {
          marginRight: rem(3),
        },
        width: `min(${rem(400)}, calc(100% - 32px))`,
        minWidth: rem(200),
      }}
      style={{
        margin: 16,
        ...(style || {}),
      }}
      InputProps={{
        startAdornment: (
          <Search
            sx={{
              color: theme.palette.secondary1,
            }}
          />
        ),
        endAdornment: searchValue && (
          <InputAdornment position="end">
            <IconButton onClick={handleClearSearch}>
              <Clear />
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  )
}

export default SearchInput
